import script from "./ReportCriterionAutocomplete.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportCriterionAutocomplete.vue?vue&type=script&setup=true&lang=js"

import "./ReportCriterionAutocomplete.vue?vue&type=style&index=0&id=55ab8330&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55ab8330"]])

export default __exports__